import React, { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export function CountUp({ value, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });

  const match = String(value).match(/^([^\d]*)(\d+)(.*)$/);
  const hasNumber = Boolean(match);
  const prefix = match ? match[1] : "";
  const target = match ? parseInt(match[2], 10) : 0;
  const suffix = match ? match[3] : String(value);

  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView || !hasNumber) return;
    let raf;
    const duration = 1400;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(eased * target));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, target, hasNumber]);

  return (
    <span ref={ref} className={className}>
      {hasNumber ? `${prefix}${display}${suffix}` : value}
    </span>
  );
}
